/*
 * Copyright (c) 2026 Gabriele Bonora. Tutti i diritti riservati.
 *
 * Software proprietario. Nessuna licenza d'uso, copia, modifica o distribuzione
 * e' concessa in assenza di autorizzazione scritta del titolare dei diritti.
 * Vedere il file LICENSE nella radice del progetto.
 */
// Validazioni lato client per il form di registrazione.
// Sono controlli di FORMATO: il backend resta l'autorita' finale (unicita', ecc.).

export const emailValida = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((v || '').trim());

// Telefono: +, spazi, trattini ammessi; 8-15 cifre effettive.
export const telefonoValido = (v) => {
  const cifre = (v || '').replace(/[^\d]/g, '');
  return /^[+\d\s.-]+$/.test((v || '').trim()) && cifre.length >= 8 && cifre.length <= 15;
};

export const capValido = (v) => /^\d{5}$/.test((v || '').trim());

// Partita IVA italiana: 11 cifre + checksum (algoritmo Luhn-like ufficiale).
export const partitaIvaValida = (v) => {
  const s = (v || '').trim();
  if (!/^\d{11}$/.test(s)) return false;
  let somma = 0;
  for (let i = 0; i < 11; i++) {
    let n = parseInt(s[i], 10);
    if (i % 2 === 1) { n *= 2; if (n > 9) n -= 9; }
    somma += n;
  }
  return somma % 10 === 0;
};

// Codice fiscale persona fisica: 16 caratteri alfanumerici nel pattern standard.
export const codiceFiscaleValido = (v) =>
  /^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/.test((v || '').trim().toUpperCase());

// Codice destinatario SDI: 7 caratteri alfanumerici.
export const codiceUnivocoValido = (v) => /^[A-Z0-9]{7}$/.test((v || '').trim().toUpperCase());

// IBAN italiano: IT + 2 check + 1 lettera (CIN) + 10 cifre (ABI+CAB) + 12 alfanumerici = 27 char.
export const ibanValido = (v) => {
  const s = (v || '').replace(/\s/g, '').toUpperCase();
  return /^IT\d{2}[A-Z]\d{10}[0-9A-Z]{12}$/.test(s);
};

// Password: minimo 8 caratteri.
export const passwordValida = (v) => (v || '').length >= 8;
